import * as Utils from './utils.js';

export default el => {
	const btns = document.querySelectorAll(`[aria-controls="${el.id}"]`);
	const box = el.querySelector('.js-dialog-box');

	btns.forEach(btn => {
		btn.addEventListener('click', () => {
			const status = el.getAttribute('aria-modal');

			if (!status || status == "false") {
				open();
				return;
			}

			close();

		})
	})

	el.addEventListener('click', (e) => {
		if (!box.contains(e.target)) {
			close();
		}	
	})

	const open = () => {
		el.style.display = "block";
		setTimeout(() => {
			el.setAttribute('aria-modal', true);
		}, 1);

		Utils.disableScroll();

		const event =  new CustomEvent("dialog", {
		 	detail: {
		    	id: el.id,
		    	open: true
		  	},
		});

		document.activeElement.blur();

		console.log(document.activeElement);

		document.dispatchEvent(event);
	}

	const close = () => {
		el.addEventListener('transitionend', () => {
			el.style.display = "none";
		}, {once: true})

		el.setAttribute('aria-modal', false);

		Utils.enableScroll();

		const event =  new CustomEvent("dialog", {
		 	detail: {
		    	id: el.id,
		    	open: false
		  	},
		});
		document.dispatchEvent(event);
	}
};
